<template>
  <div :key="containerKey">
    <header-wrap></header-wrap>
    <secord-nav></secord-nav>
    <div class="area_title">
      <h1>{{ newsPage.title }}</h1>
      <!-- 面包屑导航栏 -->
      <div class="breadcrumb_wrap">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">{{ navbar.home }}</el-breadcrumb-item>
          <el-breadcrumb-item>
            <span class="is-link" @click="onBack">{{ navbar.news }}</span>
          </el-breadcrumb-item>
          <el-breadcrumb-item v-if="activeNameText !== ''">
            {{ activeNameText }}
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>

    <!-- tab 导航栏 -->
    <div class="area_cation">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <template v-for="item in newsPage.tabs">
          <el-tab-pane :label="item[`${currentLang.prefix}title`]" :name="item.name"> </el-tab-pane>
        </template>
        <!-- <el-tab-pane label="文章介绍" name="14"></el-tab-pane> -->
      </el-tabs>
    </div>


    <div class="xc_wrap" :data-masonry='`{ "itemSelector": ".grid-item", "columnWidth": ${gridItemSize} }`'>
      <div class="grid-item" v-for="item in xcList" :key="item.id" ref="gridItemRef">
        <img :src="item.image" alt="" class="n_img" />
        <div class="news_title">{{ item[`${currentLang.prefix}title`] }}</div>
        <p class="create-time">
          <span>{{ item.publish_time_txt ? item.publish_time_txt.split(' ')[0] : "" }}</span>
        </p>
        <div @click="goNdetail(item)" class="dynamic_btn">
          <span>MORE</span>
          <img class="more_btn" src="../../assets/images/public/arrow1.png" alt="" />
        </div>
      </div>
    </div>
    <div class="sc_pagi" v-if="total !== 0">
      <el-pagination background layout="prev, pager, next" :page-size="pageSize" :current-page="page" :total="total"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>
    <footer-wrap></footer-wrap>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getCaseList } from "@/utils/http.js";
import Masonry from "masonry-layout";
export default {
  inject: ['reload'],

  data() {
    return {
      activeName: "9",
      activeNameText: "",
      xcList: [],
      total: 0,
      page: 1,
      pageSize: 15,
      gridItemSize: 400,
      debounceTimer: null,
      containerKey: 0,
    };
  },

  computed: {
    ...mapGetters(["currentLang"]),
    newsPage() {
      return this.currentLang.config.newsPage;
    },
    navbar() {
      return this.currentLang.config.navbar;
    }
  },

  created() {
    this.activeNameText = this.newsPage.tabs[0].title;
    if (this.$route.query.index) {
      this.activeName = this.$route.query.index
      this.setNavActiveNameText(this.activeName)
    }
    if (this.$route.query.page) {
      this.page = parseInt(this.$route.query.page)
    }
    this.getNewList();
  },

  updated() {
    this.handleMasonry()
  },
  mounted() {
    this.handleMasonry()

    window.addEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer)
        this.debounceTimer = null
      }
      this.debounceTimer = setTimeout(() => {
        this.handleMasonry().then(() => {
          this.containerKey += 1
        })
      }, 50)
    },

    handleMasonry() {
      return new Promise((resolve) => {
        this.$nextTick(() => {
          let size = 0
          if (this.$refs.gridItemRef && this.$refs.gridItemRef.length > 0) {
            let info = this.$refs.gridItemRef[0]
            let styleInfo = window.getComputedStyle(info)
            size = info.clientWidth + (styleInfo.marginRight.replace('px', '') - 0)
          }
          this.gridItemSize = size > 0 ? size : 400
          const grid = document.querySelector(".xc_wrap");
          const msnry = new Masonry(grid, {
            // options...
            itemSelector: ".grid-item",
            // columnWidth: 400,
            columnWidth: size > 0 ? size : 400
          });
          resolve()
        })
      })
    },

    setNavActiveNameText(active) {
      const { tabs } = this.newsPage
      tabs.forEach(item => {
        if(item.name === active){
          this.activeNameText = item.title
        }
      });
    },

    onBack() {
      this.activeName = '9'
      this.handleClick()
    },

    getNewList() {
      this.xcList = []
      getCaseList({
        cate_id: this.activeName,
        page: this.page,
        limit: this.pageSize
      }).then(res => {
        console.log(res);
        if (res.code === 1) {
          this.total = res.data.count;
          this.xcList = res.data.list;
        }
        setTimeout(() => {
          this.handleResize()
        }, 50)
      });
    },
    handleClick(tab) {
      this.page = 1
      this.activeNameText = tab && tab.label ? tab.label : this.activeNameText;
      this.$router.push({ path: "/news", query: { index: this.activeName, page: 1 } })
      this.reload();
    },
    goNdetail(info) {
      this.$router.push({
        path: "/nText",
        query: { id: info.id ? info.id : '', activeNameText: info.cate ? info.cate.cate_name : (this.activeName ? this.activeNameText : ''), page: this.page }
      });
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getNewList();
      this.$router.push({
        query: {
          ...this.$route.query,
          page: val
        }
      })
    }
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }
};
</script>
<style lang="scss" scoped>
.area_title {
  width: 100%;
  height: 160px;
  line-height: 160px;
  background: url("../../assets/images/public/i12.jpg") no-repeat;
  background-size: 100% 100%;
  background-size: cover;
  background-position: center center;
  text-align: center;
  position: relative;

  h1 {
    color: white;
    font-weight: normal;
  }

  .breadcrumb_wrap {
    width: 1200px;
    position: absolute;
    top: 15px;
    left: calc(50% - 600px);

    /deep/ .el-breadcrumb__item {
      span {
        color: #fff;
        font-size: 16px;
        font-weight: normal;
      }
    }
  }
}

.area_cation {
  display: flex;
  justify-content: center;

  /deep/ .el-tabs {
    width: 100%;

    .el-tabs__header {
      height: 60px;
      line-height: 60px;
      background: #4b4b4b;
      border: 0;
      // width: 1200px;
      margin: 0;
      display: flex;
      align-items: center;
      justify-content: center;

      .el-tabs__nav-wrap {
        height: 100%;
        margin-bottom: 0;

        .el-tabs__nav-scroll {
          height: 100%;

          .el-tabs__nav {
            height: 100%;
            border: 0;

            .el-tabs__item {
              height: 100%;
              color: #979797;
              border-left: none;
              border-bottom: none;
              padding: 0 25px;
              line-height: unset;
              font-size: 16px;
            }

            .is-active {
              background: #646464;
            }
          }
        }
      }
    }
  }
}

.xc_wrap {
  width: 1200px;
  height: auto;
  min-height: 50vh;
  margin: 50px auto;

  .grid-item {
    overflow: hidden;
    width: calc(1200px / 3 - 40px);
    height: auto;
    background: #f5f5f5;
    margin-right: 30px;
    margin-bottom: 20px;
    display: inline-block;
    border-radius: 8px;

    &:hover {
      box-shadow: 0 0 10px 0px rgba($color: #000000, $alpha: 0.2);
      // transform: scale(1.025) translate3d(0, 0, 0);
      // -webkit-font-smoothing: antialiased;
    }

    .n_img {
      display: block;
      width: 100%;
      height: auto;
    }

    .news_title {
      line-height: 1.6;
      margin-top: 18px;
      padding: 0 20px;
      font-size: 18px;
      color: var(--main-color-blue);
      font-weight: 500;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      /* 显示的行数 */
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .dynamic_time {
      margin-left: 30px;
      font-size: 16px;

      span:first-child {
        color: #666;
      }

      span:last-child {
        color: #003359;
        margin-left: 10px;
      }
    }

    .create-time {
      margin: 32px 0 18px;
      padding: 0 20px;
      font-size: 17px;
      font-weight: 300;
      color: #666;
    }

    .dynamic_btn {
      width: 140px;
      height: 45px;
      margin: 0 0 20px 20px;
      background: #e8363e;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      cursor: pointer;

      .more_btn {
        width: 40px;
        margin-left: 10px;
      }
    }
  }

  .grid-item:nth-child(3n) {
    margin-right: 0;
  }

  .sign_wrap {
    width: 320px;
    height: auto;
    padding: 30px 15px 30px 25px;
    background: #003359;

    .sign_title {
      font-size: 16px;
      color: #a5a5a5;
    }

    .sign_list {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      font-size: 14px;
      color: #fff;
      margin-top: 20px;

      span {
        margin-right: 10px;
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }

  //   ul {
  //     width: 1200px;
  //     flex-wrap: wrap;
  //     display: flex;
  //     justify-content: space-around;
  //   }

  //   li {
  //     ;
  //     height: auto;
  //
  //     margin: 30px 0;

  //
  //   }
}

.sc_pagi {
  width: 500px;
  margin: 0 auto 50px;
  display: flex;
  justify-content: center;

  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background: #e8363e;
  }
}

// .el-tabs__nav-wrap {
//   margin-bottom: 0;
// }

// .el-tabs--card>.el-tabs__header .el-tabs__nav {
//   border: 0;

// }

// .el-tabs--card>.el-tabs__header {
//   border: 0;
//   width: 850px;
//   margin: auto;
// }

// .el-tabs--card>.el-tabs__header .el-tabs__item {
//   border-left: 0;
//   border-bottom: 0;
// }

// .el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
//   background: #646464;
// }

// .el-tabs--top.el-tabs--card>.el-tabs__header .el-tabs__item:nth-child(2) {
//   padding-left: 50px;
// }

// .el-tabs--top.el-tabs--card>.el-tabs__header .el-tabs__item:last-child {
//   padding-right: 50px;
// }

// .el-tabs__item {
//   height: 40px;
//   color: gray;
//   padding: 0 50px;
// }

// .el-tabs__item.is-active {
//   color: white;
// }

// .el-tabs__nav-wrap {
//   height: 40px;
// }

// .el-tabs__item:hover {
//   color: gray;
// }

// .el-tabs--card>.el-tabs__header .el-tabs__item.is-active:hover {
//   color: white;
// }

// .el-pagination.is-background .el-pager li:not(.disabled).active {
//   background-color: #e8363e;
// }</style>



// WEBPACK FOOTER //
// src/pages/news/news.vue